import React, { FC, useEffect, useState } from 'react'
import { Link as MUILink } from '@ally/metronome-ui'
import { Link, useHistory } from 'react-router-dom'
import { useHostServices } from '../../HostServices'
import { getTransferTicket } from '../../utils/transferTicket'
import { Error } from '../Error'
import { Loader } from '../Loader'
import { autoBaseUrl } from '../../constants'
import { autoRedirects } from './redirects'

function getDestinationURL(ticketID: string): string {
  const { pathname, searchParams } = new URL(window.location.toString())
  searchParams.append('ticketID', ticketID)
  const destination = pathname.replace(/^\/sso\/auto/, '') ?? '/'
  return `${autoBaseUrl}/#/auto${destination}?${searchParams.toString()}`
}

export const Auto: FC = () => {
  const {
    transmitRef,
    session,
    log: { track },
    featureFlags,
  } = useHostServices()
  const [failed, setFailed] = useState(false)

  const history = useHistory()

  useEffect(() => {
    track('ally-next-remote-sso-auto-init')
  }, [])

  useEffect(() => {
    // Wait for authenticated feature flags - The rollout of Auto Ally Next remotes will be
    // a percentage based on the user's aaosId, so we need to wait for authed flags or else
    // a user could mistakenly be sent to AAOS Ember when the shouldn't be.
    if (featureFlags.auto.loadState !== 'loaded') return
    // Check if the route is a known Auto redirect (experience migrated from Legacy to Next)
    // Using window.location instead of useLocation() from react-router dom because query
    // params where getting appended to the "pathname" prop instead of on their own in "search"
    const foundRedirect = autoRedirects.match(window.location, featureFlags)
    if (foundRedirect) {
      track('ally-next-remote-sso-auto-redirect')
      const destination = autoRedirects.redirectURL(window.location)
      track('ally-next-remote-sso-auto-done')
      history.replace(destination)
      return
    }
    // Else start the sso process to legacy
    getTransferTicket(transmitRef, session.data, 'auto')
      .then(ticketID => {
        const destination = getDestinationURL(ticketID)
        track('ally-next-remote-sso-auto-done')
        window.location.replace(destination)
      })
      .catch(() => {
        track('ally-next-remote-sso-auto-error')
        setFailed(true)
      })
  }, [featureFlags.auto.loadState])

  return (
    <>
      <Loader description="We're taking you to your auto accounts." />
      {failed && (
        <Error
          errorMessage={
            <>
              We&apos;ve hit a roadblock on the way to your auto accounts.
              We&apos;re working on a fix, so try again in a bit.{' '}
              <MUILink
                variant="link"
                text="Go to Snapshot"
                allytmln="goToSnapshot"
              >
                <Link to="/dashboard" />
              </MUILink>
            </>
          }
        />
      )}
    </>
  )
}
